<template>
  <v-card title="考勤维护">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div style="text-align: left">
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="kqyf"
                  placeholder="考勤月份"
                  type="month"
                  valueFormat="yyyyMM"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <v-input placeholder="输入工号或姓名" v-model="gh"></v-input>
              </v-form-item>
              <v-form-item>
                <!-- <v-select placeholder="请选择客户" style="width: 150px;" :data="khbh_options" v-model="khbh"></v-select> -->
                <vxe-select v-model="khbh" size="mini" placeholder="请选择客户" :options="khbh_options" clearable @change="xz_khbh"></vxe-select>
              </v-form-item>              
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>              
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>            
            <v-popconfirm
              title="确定删除吗?"
              @confirm="del(row)"
              @cancel="cancel"
              placement="bottomRight"
            >
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到考勤信息！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      khbh_options: [],      
      khbh:"",
      gh:"",
      kqyf: dateFormat("YYYYmm", new Date()),
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 500,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true,
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true,
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "kqyf",
            title: "考勤月份",
            align: "center",
          },
          {
            field: "khbh",
            title: "客户编号",
            align: "center",
          },
          {
            field: "gh",
            title: "工号",
            align: "center",
          },
          {
            field: "xm",
            title: "姓名",
            align: "center",
          },
          {
            field: "cqts",
            title: "出勤天数",
            align: "center",
          },
          {
            field: "jb",
            title: "加班（小时）",
            align: "center",
          },
          {
            field: "xj",
            title: "休假（小时）",
            align: "center",
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz",
            },
          },
        ],
      },
    };
  },
  created() {
    this.init_khbh();
    // this.findList();
  },
  methods: {
    findList() {
      if(this.kqyf == ""){
        this.$message["error"]("请选择考勤月份！");
        return;
      }
      this.$axios
        .get(
          "api/system/sjwh/get-sjwh-kqcx?kqyf=" +
            this.kqyf +
            "&khbh=" +
            this.khbh+
            "&gh=" +
            this.gh
        )
        .then((res) => {
          this.tableData = res.data.data;
        //   this.sql = res.data.sql;
        });
    },
    init_khbh: function () {
      this.$axios.get("api/system/rywh/get-rywh-khbh").then((res) => {
        let self = this;
        self.khbh_options = res.data.map((item) => {
          return { value: item.khbh, label: item.khjc };
        });
      });
    },
    del: function (row) {
      this.$axios
        .get("api/system/sjwh/del-sjwh-kqsj?kqyf=" + row.kqyf+"&gh="+row.gh)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    cancel: function () {
      this.$message.info("取消删除");
    },
  },
};
function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/sjwh/kqwh.vue